import React from 'react';
import PropTypes from 'prop-types';

export const SvgGps = ({ width, height }) => (
  <svg width={width || '14px'} height={height || '18px'} viewBox="0 0 14 18" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g transform="translate(-212.000000, -406.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(210.000000, 400.000000)">
          <g transform="translate(-3.000000, 3.000000)">
            <path d="M18,10.6666668 C18,15.3333333 12,19.3333333 12,19.3333333 C12,19.3333333 6,15.3333333 6,10.6666668 C6,7.3529582 8.68629154,4.66666676 12,4.66666676 C15.3137085,4.66666676 18,7.3529582 18,10.6666668 L18,10.6666668 Z" />
            <circle cx="12" cy="10.6666667" r="2" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgGps.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
